import React__default from 'react';
import styled from '@emotion/styled';

const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ React__default.createElement(Wrapper, {
  className
}, /* @__PURE__ */ React__default.createElement(Title, null, children));
const Wrapper = styled.div`
  padding: 1rem;
  text-align: center;
`;
const Title = styled.h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
`;

export { ModalHeader };
